import { render, staticRenderFns } from "./DocumentType.vue?vue&type=template&id=dbfedbea&scoped=true"
import script from "./DocumentType.vue?vue&type=script&lang=js"
export * from "./DocumentType.vue?vue&type=script&lang=js"
import style0 from "./DocumentType.vue?vue&type=style&index=0&id=dbfedbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfedbea",
  null
  
)

export default component.exports